var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.187 3.511a.514.514 0 0 0-.707 0L4.067 14.924a.5.5 0 0 0 0 .707l4.28 4.28a.5.5 0 0 0 .707 0L20.467 8.5a.5.5 0 0 0 0-.707Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 16.71a.5.5 0 0 0-.828.2l-2.14 6.42a.5.5 0 0 0 .12.512.508.508 0 0 0 .512.121l6.42-2.139a.5.5 0 0 0 .2-.829Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.968 1.017a3.613 3.613 0 0 0-4.988 0l-.712.713a.5.5 0 0 0 0 .707l4.279 4.28a.5.5 0 0 0 .707 0L22.968 6a3.53 3.53 0 0 0 0-4.983Z"
})));
export { SvgPencil as ReactComponent };
export default __webpack_public_path__ + "15765a70e0694a725017eccd2d8b68f3928e2754d01bf7031cfab4779ed31c12.svg";